export default "__VITE_ASSET__CTmvLJ6F__"